// Этап 6, раздел 6 «Возвраты» (docs/PLAN.md) — строка таблицы платежей в UserCardScreen.tsx.
// Кнопка "Вернуть" показана только для успешных платежей — backend всё равно отклонит остальные
// статусы 409, но не показывать заведомо нерабочую кнопку понятнее для админа.
import { useState } from "react";

import { type AdminPayment, ApiError, refundPayment } from "../api/client";

const PAYMENT_STATUS_LABEL: Record<string, string> = {
  pending: "в обработке",
  succeeded: "оплачен",
  failed: "не прошёл",
  refunded: "возвращён",
};

const PAYMENT_TYPE_LABEL: Record<string, string> = {
  purchase: "покупка",
  renewal: "продление",
  upgrade: "апгрейд",
  refund: "возврат",
};

function formatDate(iso: string): string {
  return new Date(iso).toLocaleString("ru-RU");
}

export function PaymentRow({
  payment,
  onChanged,
}: {
  payment: AdminPayment;
  onChanged: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [revokeLicense, setRevokeLicense] = useState(false);
  const [note, setNote] = useState<string | null>(null);

  async function refund() {
    setBusy(true);
    setError(null);
    setNote(null);
    try {
      const result = await refundPayment(payment.id, revokeLicense);
      if (revokeLicense && !result.license_revoked) {
        // Возврат денег состоялся в любом случае — это просто информирует, что вторая, побочная
        // часть действия (отзыв лицензии) не сработала, см. app/schemas/admin_refund.py.
        setNote(`Платёж возвращён, но лицензию отозвать не удалось: ${result.license_revoke_error}`);
      }
      onChanged();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Не удалось оформить возврат");
    } finally {
      setBusy(false);
    }
  }

  return (
    <tr>
      <td>{formatDate(payment.created_at)}</td>
      <td>
        {payment.amount} {payment.currency}
      </td>
      <td>{PAYMENT_TYPE_LABEL[payment.type] ?? payment.type}</td>
      <td>{PAYMENT_STATUS_LABEL[payment.status] ?? payment.status}</td>
      <td>{payment.provider === "telegram" ? "Telegram" : "ЮKassa"}</td>
      <td>{payment.provider_payment_id}</td>
      <td style={{ whiteSpace: "nowrap" }}>
        {payment.status === "succeeded" && (
          <>
            <label style={{ fontSize: 13, marginRight: 8 }}>
              <input
                type="checkbox"
                checked={revokeLicense}
                onChange={(e) => setRevokeLicense(e.target.checked)}
              />{" "}
              и лицензию
            </label>
            <button className="secondary" disabled={busy} onClick={refund}>
              Вернуть
            </button>
          </>
        )}
        {error && <div className="error-text" style={{ marginTop: 8, marginBottom: 0 }}>{error}</div>}
        {note && <div style={{ marginTop: 8, fontSize: 13, color: "var(--text-muted)" }}>{note}</div>}
      </td>
    </tr>
  );
}
